import React, { useState } from 'react'; 
import './blog-post.css'; 
import './blog-slides.css';  
//pictures here
import hiya1 from './pictures/hiya1.jpg';  
import hiya2 from './pictures/hiya2.jpg';
import hiya3 from './pictures/hiya3.jpg'; 
import hiya4 from './pictures/hiya4.jpg';  

const Hiya = () => {
  return (
    <div>
      <div className='blog__container'>
        <div className="row">
          <div className="column">
            <header>
              <h3 className="site-post-title rounded title-padding">
                <b>WiC at Work</b>
              </h3>
            </header>
            <section>
              <h2>WiC x Hiya Office Trek!</h2>
              <p className="site-post-meta">May 20, 2025</p>
              <hr />
            </section>
            <section>
              <p>

              Hi WiC!

              <br></br>
              <br></br>

              Thank you to everyone who joined us for our recent visit to the Hiya office in Seattle! We had an incredible time touring the Columbia Center and learning more about Hiya’s innovative work in spam call protection and voice security.

              <br></br>
              <br></br>

              The event featured an inspiring panel of women professionals from across the company, including engineering, product, HR, and more. Panelists shared thoughtful insights about their career journeys, the unique challenges and opportunities they’ve encountered in tech, and what it’s like to work at Hiya. We appreciated their openness and advice, and the chance to hear so many different perspectives in one room.

              <br></br>
              <br></br>

              In addition to the panel, we enjoyed a guided tour of the office with its views of Seattle and a chance to get a closer look at Hiya’s workplace culture. It was a valuable opportunity to ask questions, connect with employees, and envision what a future in tech might look like.

                
              <br></br>
              <br></br>

              We are so glad we got to explore the Columbia Center and spend time with such a welcoming team. Thank you again to Hiya for hosting us!

              </p>
              <img src={hiya1} alt="Recap 1" />
              <img src={hiya2} alt="Recap 2" />
              <img src={hiya3} alt="Recap 3" />
              <img src={hiya4} alt="Recap 4" />
              
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hiya;